import { SearchElementInterface, SearchResultInterface } from '@elearning-platform/api-types/interfaces';

import { api } from '../api';

export const searchResults: (query: string) => Promise<SearchResultInterface[]>
= (query: string): Promise<SearchResultInterface[]> => api.get('v1/search', { params: { search: query } });

export const searchNewsResults: (query: string) => Promise<SearchElementInterface[]>
= (query: string): Promise<SearchElementInterface[]> => api.get('search', { params: { query } });
